module.exports = __webpack_public_path__ + "static/media/Img2.f5d8c9fc.png";